import React, { useEffect, useState, useMemo } from 'react';
import TileWithGroup from './TileWithGroup/index';
import cn from 'classnames';
import style from './checksCardWithGroup.module.scss';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';
import { safeJsonParse } from '../../../../../../utility/helperFunction';

const ChecksCardWithGroup = props => {
  const {
    checks,
    checksCount,
    setSelectedCheck,
    selectedCheck,
    checkFilters,
    currentMode,
  } = props;
  const SOURCETYPE = 'sourceType';
  const flabel = FLABEL();
  const deviceGroup = safeJsonParse(window.sessionStorage.getItem('deviceInfo'), {})
    ?.deviceGroup;
  const sourceTypeMap = useMemo(
    () => ({
      0: FLABEL().CHANNEL_POS,
      1: FLABEL().CHANNEL_KIOSK,
      3: FLABEL().CHANNEL_ORDER_PAY,
      5: FLABEL().CHANNEL_CURBSIDE,
      6: FLABEL().CHANNEL_ONLINE,
      7: FLABEL().CHANNEL_WALKUP,
      8: FLABEL().CHANNEL_CALL_IN,
      9: FLABEL().CHANNEL_COUNTER,
      10: FLABEL().CHANNEL_CALL_CENTER,
      11: FLABEL().CHANNEL_SPEED_ORDER,
      12: FLABEL().CHANNEL_DRIVE_THRU,
    }),
    [flabel]
  );

  const filters = deviceGroup?.fireBoardCheckFilters;
  const SOURCETYPE_ARRAY = useMemo(() => {
    // If channel filters exist and have values show only those
    if (
      deviceGroup?.fireBoardCheckFilterType === 0 &&
      Array.isArray(filters) &&
      filters.length > 0
    ) {
      return filters
        .map(type => String(type))
        .filter(type => sourceTypeMap[type] !== undefined);
    }
    return Object.keys(sourceTypeMap);
  }, [sourceTypeMap]);
  const [groupChecks, setGroupChecks] = useState(new Map());

  useEffect(() => {
    filterChecks();
    if (!selectedCheck) {
      initalTileSelected();
    }
  }, [checks, checkFilters]);

  const filterChecks = () => {
    const { activeCheckFilter } = checkFilters;
    let checksMap = new Map();
    switch (activeCheckFilter) {
      case SOURCETYPE:
        checksMap = filterBasedOnODOrderType();
        break;
      default:
        checksMap = filterBasedOnODOrderType();
        break;
    }
    setGroupChecks(checksMap);
  };

  const filterBasedOnODOrderType = () => {
    let checksMap = new Map();

    SOURCETYPE_ARRAY.forEach(type => checksMap.set(String(type), []));

    checks.forEach(check => {
      let typeKey = String(check.sourceType);

      if (checksMap.has(typeKey)) {
        const existingCheck = checksMap.get(typeKey) || [];
        checksMap.set(typeKey, [...existingCheck, check]);
      }
    });

    return checksMap;
  };

  const initalTileSelected = () => {
    const initialArr = Array.from(groupChecks.entries()).find(
      ([key, chk]) => chk.length
    );
    const firstArr = Array.isArray(initialArr) && initialArr[1];
    setSelectedCheck(firstArr[0]?.id);
  };

  return (
    <div className="col-12 px-0">
      {Array.from(groupChecks.entries()).map(([key, checkArray]) => (
        <div className="w-100" key={key}>
          <Divider
            SourceTypeName={sourceTypeMap[key]}
            length={checkArray.length}
          />{' '}
          {checkArray?.length === 0 ? (
            <NoSourceItemsFound />
          ) : (
            <div className={cn('col-12 px-0 py-2', style.ChecksCard)}>
              {checkArray?.map((check, index) => (
                <TileWithGroup
                  check={check}
                  rowIndex={index}
                  selectedCheck={selectedCheck}
                  setSelectedCheck={setSelectedCheck}
                  checksCount={checksCount}
                  currentMode={currentMode}
                />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ChecksCardWithGroup;

const Divider = ({ SourceTypeName, length }) => {
  return (
    <div className={cn(style.dividerContainer)}>
      {SourceTypeName} ({length})
    </div>
  );
};

const NoSourceItemsFound = () => {
  return <div className={cn(style.noSectionCheck)}>No Record Found</div>;
};
